import { defineStore } from "pinia";
import { apiUser } from "@/components/toLoad/api";
import { captureException } from "@/posthog";

export const useCompanyStore = defineStore("company", {
  state: () => ({
    company: null,
    loading: false,
    modules: [],
  }),
  actions: {
    resetState() {
      this.company = null;
      this.modules = [];
      this.loading = false;
    },

    cleanupListeners() {},

    async initCompanyListener(companyId) {
      if (!companyId) {
        this.resetState();
        return;
      }

      this.loading = true;
      try {
        const { data } = await apiUser({
          method: "get",
          url: `/companies/${companyId}`,
        });
        const { modules, ...company } = data;
        this.company = company;
        this.modules = modules || [];
      } catch (error) {
        console.error("Error fetching company:", error);
        captureException(error, { flow: "company_listener" });
        this.company = null;
        this.modules = [];
      } finally {
        this.loading = false;
      }
    },

    stopCompanyListener() {
      this.resetState();
    },
  },
});
